import Icon from '../components/Icon.vue'

Icon.register({
  'door-open': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M624 448H544V113.4C544 86.2 522.5 64 496 64H384V128H480V512H624C632.8 512 640 504.8 640 496V464C640 455.2 632.8 448 624 448zM312.2 1L120.2 50.8C106 54.4 96 67.7 96 82.9V448H16C7.2 448 0 455.2 0 464V496C0 504.8 7.2 512 16 512H352V33.2C352 11.6 332.4-4.2 312.2 1zM264 288C250.8 288 240 273.7 240 256S250.8 224 264 224 288 238.3 288 256 277.3 288 264 288z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/door-open.js
// module id = cDDG
// module chunks = 144